<template>
  <div class="actionsWrapper">
    <font-awesome-icon
      v-if="actions.includes('edit')"
      @click="openSection"
      :icon="['fas', 'pen-to-square']"
      class="icon"
    />
    <font-awesome-icon
      v-if="actions.includes('add')"
      @click="addSectionItem"
      :icon="['fas', 'plus']"
      class="icon"
    />
    <font-awesome-icon
      v-if="actions.includes('delete')"
      @click="deleteSection"
      :icon="['far', 'trash-can']"
      class="icon"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, nextTick, PropType } from 'vue'
import {
  GlobalEvents,
  useGlobalListeners,
} from '@/composables/useGlobalListeners'
import { useStructuredResumeStore } from '@/store/pinia/structuredResume'
import { useConfirmationDialog } from '@/composables/useConfirmationDialog'

export default defineComponent({
  name: 'SectionActions',
  props: {
    section: {
      type: String as PropType<string>,
      required: true,
    },
    actions: {
      type: Array as PropType<string[]>,
      default: () => ['add', 'delete'],
    },
  },
  setup(props) {
    const { appConfirm } = useConfirmationDialog()
    const store = useStructuredResumeStore()
    const { publishEvent } = useGlobalListeners()
    const openSection = () => {
      publishEvent(GlobalEvents.PE_EDIT_SECTION, { section: props.section })
    }
    const deleteSection = async () => {
      if (
        await appConfirm(
          'Are you sure you want to delete this section from your resume?',
          'Delete Section',
          'Delete',
          'danger'
        )
      ) {
        store.removeSection(props.section)
      }
    }
    const addSectionItem = async () => {
      const uuid = store.addSectionItem(props.section)
      await nextTick()
      publishEvent(GlobalEvents.PE_EDIT_SECTION, {
        section: props.section,
        uuid,
      })
    }
    return {
      openSection,
      deleteSection,
      addSectionItem,
    }
  },
})
</script>

<style lang="postcss" scoped>
.actionsWrapper {
  @apply flex flex-row flex-nowrap text-primary;
  .icon {
    @apply cursor-pointer text-xs rounded p-1 ml-1 hover:bg-jsBlue-20;
  }
}
</style>
